(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._tooltip_12yf1_1{width:260px}._bar_oizm2_27{overflow:hidden}._section_oizm2_31{position:relative}._sectionHidden_oizm2_34{display:none!important}._sectionInheritRadius_oizm2_37{border-radius:inherit}._valueOutside_oizm2_41{position:absolute;left:calc(100% + 4px);z-index:1}._wrapper_1q643_27{display:inline-flex;align-self:flex-start}._text_1q643_32{font-size:24px}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}")),document.head.appendChild(e)}}catch(i){console.error("vite-plugin-css-injected-by-js",i)}})();
import cr, { cloneElement as Dn, useState as Ae, useEffect as It, useMemo as ne, memo as Se, createElement as Mn, useRef as Fn, useCallback as zr } from "react";
import { DropdownButton as Nn, DropdownButtonContext as Ln, ButtonList as qe, FlexBox as U, Text as G, Tooltip as fr, Box as dr, Table as B, EmptyState as Vn, HelpIcon as Un, Button as kn, Pagination as Gn } from "@dixa/lib-shared-habla";
import { sizes as Bn, colors as A, typography as Hn } from "@dixa/lib-shared-tokens";
import rr from "classnames";
import { usePrevious as zn, useInterval as Wn, useUpdateEffect as Dt } from "react-use";
import { TagChips as Kn } from "lib-shared-tagging";
import qn from "moment-timezone";
var we = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Yn(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), t;
}
var tr = { exports: {} }, Ye = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Je, Wr;
function Ft() {
  if (Wr)
    return Je;
  Wr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, u = 0; u < 10; u++)
        o["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(o).map(function(v) {
        return o[v];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        c[v] = v;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Je = a() ? Object.assign : function(s, o) {
    for (var u, l = n(s), c, v = 1; v < arguments.length; v++) {
      u = Object(arguments[v]);
      for (var g in u)
        r.call(u, g) && (l[g] = u[g]);
      if (e) {
        c = e(u);
        for (var h = 0; h < c.length; h++)
          t.call(u, c[h]) && (l[c[h]] = u[c[h]]);
      }
    }
    return l;
  }, Je;
}
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kr;
function Jn() {
  return Kr || (Kr = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var r = cr, t = Ft(), n = 60103, a = 60106;
      e.Fragment = 60107;
      var s = 60108, o = 60114, u = 60109, l = 60110, c = 60112, v = 60113, g = 60120, h = 60115, m = 60116, $ = 60121, w = 60122, O = 60117, S = 60129, x = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var _ = Symbol.for;
        n = _("react.element"), a = _("react.portal"), e.Fragment = _("react.fragment"), s = _("react.strict_mode"), o = _("react.profiler"), u = _("react.provider"), l = _("react.context"), c = _("react.forward_ref"), v = _("react.suspense"), g = _("react.suspense_list"), h = _("react.memo"), m = _("react.lazy"), $ = _("react.block"), w = _("react.server.block"), O = _("react.fundamental"), _("react.scope"), _("react.opaque.id"), S = _("react.debug_trace_mode"), _("react.offscreen"), x = _("react.legacy_hidden");
      }
      var N = typeof Symbol == "function" && Symbol.iterator, I = "@@iterator";
      function W(i) {
        if (i === null || typeof i != "object")
          return null;
        var f = N && i[N] || i[I];
        return typeof f == "function" ? f : null;
      }
      var M = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function C(i) {
        {
          for (var f = arguments.length, p = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
            p[y - 1] = arguments[y];
          L("error", i, p);
        }
      }
      function L(i, f, p) {
        {
          var y = M.ReactDebugCurrentFrame, T = y.getStackAddendum();
          T !== "" && (f += "%s", p = p.concat([T]));
          var P = p.map(function(E) {
            return "" + E;
          });
          P.unshift("Warning: " + f), Function.prototype.apply.call(console[i], console, P);
        }
      }
      var K = !1;
      function X(i) {
        return !!(typeof i == "string" || typeof i == "function" || i === e.Fragment || i === o || i === S || i === s || i === v || i === g || i === x || K || typeof i == "object" && i !== null && (i.$$typeof === m || i.$$typeof === h || i.$$typeof === u || i.$$typeof === l || i.$$typeof === c || i.$$typeof === O || i.$$typeof === $ || i[0] === w));
      }
      function Ve(i, f, p) {
        var y = f.displayName || f.name || "";
        return i.displayName || (y !== "" ? p + "(" + y + ")" : p);
      }
      function ye(i) {
        return i.displayName || "Context";
      }
      function k(i) {
        if (i == null)
          return null;
        if (typeof i.tag == "number" && C("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof i == "function")
          return i.displayName || i.name || null;
        if (typeof i == "string")
          return i;
        switch (i) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case o:
            return "Profiler";
          case s:
            return "StrictMode";
          case v:
            return "Suspense";
          case g:
            return "SuspenseList";
        }
        if (typeof i == "object")
          switch (i.$$typeof) {
            case l:
              var f = i;
              return ye(f) + ".Consumer";
            case u:
              var p = i;
              return ye(p._context) + ".Provider";
            case c:
              return Ve(i, i.render, "ForwardRef");
            case h:
              return k(i.type);
            case $:
              return k(i._render);
            case m: {
              var y = i, T = y._payload, P = y._init;
              try {
                return k(P(T));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var ce = 0, Or, xr, Tr, Pr, jr, Cr, Ar;
      function Sr() {
      }
      Sr.__reactDisabledLog = !0;
      function pn() {
        {
          if (ce === 0) {
            Or = console.log, xr = console.info, Tr = console.warn, Pr = console.error, jr = console.group, Cr = console.groupCollapsed, Ar = console.groupEnd;
            var i = {
              configurable: !0,
              enumerable: !0,
              value: Sr,
              writable: !0
            };
            Object.defineProperties(console, {
              info: i,
              log: i,
              warn: i,
              error: i,
              group: i,
              groupCollapsed: i,
              groupEnd: i
            });
          }
          ce++;
        }
      }
      function vn() {
        {
          if (ce--, ce === 0) {
            var i = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, i, {
                value: Or
              }),
              info: t({}, i, {
                value: xr
              }),
              warn: t({}, i, {
                value: Tr
              }),
              error: t({}, i, {
                value: Pr
              }),
              group: t({}, i, {
                value: jr
              }),
              groupCollapsed: t({}, i, {
                value: Cr
              }),
              groupEnd: t({}, i, {
                value: Ar
              })
            });
          }
          ce < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Ue = M.ReactCurrentDispatcher, ke;
      function me(i, f, p) {
        {
          if (ke === void 0)
            try {
              throw Error();
            } catch (T) {
              var y = T.stack.trim().match(/\n( *(at )?)/);
              ke = y && y[1] || "";
            }
          return `
` + ke + i;
        }
      }
      var Ge = !1, _e;
      {
        var hn = typeof WeakMap == "function" ? WeakMap : Map;
        _e = new hn();
      }
      function Rr(i, f) {
        if (!i || Ge)
          return "";
        {
          var p = _e.get(i);
          if (p !== void 0)
            return p;
        }
        var y;
        Ge = !0;
        var T = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var P;
        P = Ue.current, Ue.current = null, pn();
        try {
          if (f) {
            var E = function() {
              throw Error();
            };
            if (Object.defineProperty(E.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(E, []);
              } catch (Y) {
                y = Y;
              }
              Reflect.construct(i, [], E);
            } else {
              try {
                E.call();
              } catch (Y) {
                y = Y;
              }
              i.call(E.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Y) {
              y = Y;
            }
            i();
          }
        } catch (Y) {
          if (Y && y && typeof Y.stack == "string") {
            for (var b = Y.stack.split(`
`), V = y.stack.split(`
`), R = b.length - 1, D = V.length - 1; R >= 1 && D >= 0 && b[R] !== V[D]; )
              D--;
            for (; R >= 1 && D >= 0; R--, D--)
              if (b[R] !== V[D]) {
                if (R !== 1 || D !== 1)
                  do
                    if (R--, D--, D < 0 || b[R] !== V[D]) {
                      var q = `
` + b[R].replace(" at new ", " at ");
                      return typeof i == "function" && _e.set(i, q), q;
                    }
                  while (R >= 1 && D >= 0);
                break;
              }
          }
        } finally {
          Ge = !1, Ue.current = P, vn(), Error.prepareStackTrace = T;
        }
        var ee = i ? i.displayName || i.name : "", Hr = ee ? me(ee) : "";
        return typeof i == "function" && _e.set(i, Hr), Hr;
      }
      function Ir(i, f, p) {
        return Rr(i, !1);
      }
      function gn(i) {
        var f = i.prototype;
        return !!(f && f.isReactComponent);
      }
      function be(i, f, p) {
        if (i == null)
          return "";
        if (typeof i == "function")
          return Rr(i, gn(i));
        if (typeof i == "string")
          return me(i);
        switch (i) {
          case v:
            return me("Suspense");
          case g:
            return me("SuspenseList");
        }
        if (typeof i == "object")
          switch (i.$$typeof) {
            case c:
              return Ir(i.render);
            case h:
              return be(i.type, f, p);
            case $:
              return Ir(i._render);
            case m: {
              var y = i, T = y._payload, P = y._init;
              try {
                return be(P(T), f, p);
              } catch {
              }
            }
          }
        return "";
      }
      var Dr = {}, Mr = M.ReactDebugCurrentFrame;
      function $e(i) {
        if (i) {
          var f = i._owner, p = be(i.type, i._source, f ? f.type : null);
          Mr.setExtraStackFrame(p);
        } else
          Mr.setExtraStackFrame(null);
      }
      function yn(i, f, p, y, T) {
        {
          var P = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var E in i)
            if (P(i, E)) {
              var b = void 0;
              try {
                if (typeof i[E] != "function") {
                  var V = Error((y || "React class") + ": " + p + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw V.name = "Invariant Violation", V;
                }
                b = i[E](f, E, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (R) {
                b = R;
              }
              b && !(b instanceof Error) && ($e(T), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, E, typeof b), $e(null)), b instanceof Error && !(b.message in Dr) && (Dr[b.message] = !0, $e(T), C("Failed %s type: %s", p, b.message), $e(null));
            }
        }
      }
      var fe = M.ReactCurrentOwner, Be = Object.prototype.hasOwnProperty, mn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Fr, Nr, He;
      He = {};
      function _n(i) {
        if (Be.call(i, "ref")) {
          var f = Object.getOwnPropertyDescriptor(i, "ref").get;
          if (f && f.isReactWarning)
            return !1;
        }
        return i.ref !== void 0;
      }
      function bn(i) {
        if (Be.call(i, "key")) {
          var f = Object.getOwnPropertyDescriptor(i, "key").get;
          if (f && f.isReactWarning)
            return !1;
        }
        return i.key !== void 0;
      }
      function $n(i, f) {
        if (typeof i.ref == "string" && fe.current && f && fe.current.stateNode !== f) {
          var p = k(fe.current.type);
          He[p] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', k(fe.current.type), i.ref), He[p] = !0);
        }
      }
      function wn(i, f) {
        {
          var p = function() {
            Fr || (Fr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
          };
          p.isReactWarning = !0, Object.defineProperty(i, "key", {
            get: p,
            configurable: !0
          });
        }
      }
      function En(i, f) {
        {
          var p = function() {
            Nr || (Nr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
          };
          p.isReactWarning = !0, Object.defineProperty(i, "ref", {
            get: p,
            configurable: !0
          });
        }
      }
      var On = function(i, f, p, y, T, P, E) {
        var b = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: i,
          key: f,
          ref: p,
          props: E,
          // Record the component responsible for creating this element.
          _owner: P
        };
        return b._store = {}, Object.defineProperty(b._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(b, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: y
        }), Object.defineProperty(b, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: T
        }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
      };
      function xn(i, f, p, y, T) {
        {
          var P, E = {}, b = null, V = null;
          p !== void 0 && (b = "" + p), bn(f) && (b = "" + f.key), _n(f) && (V = f.ref, $n(f, T));
          for (P in f)
            Be.call(f, P) && !mn.hasOwnProperty(P) && (E[P] = f[P]);
          if (i && i.defaultProps) {
            var R = i.defaultProps;
            for (P in R)
              E[P] === void 0 && (E[P] = R[P]);
          }
          if (b || V) {
            var D = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
            b && wn(E, D), V && En(E, D);
          }
          return On(i, b, V, T, y, fe.current, E);
        }
      }
      var ze = M.ReactCurrentOwner, Lr = M.ReactDebugCurrentFrame;
      function Q(i) {
        if (i) {
          var f = i._owner, p = be(i.type, i._source, f ? f.type : null);
          Lr.setExtraStackFrame(p);
        } else
          Lr.setExtraStackFrame(null);
      }
      var We;
      We = !1;
      function Ke(i) {
        return typeof i == "object" && i !== null && i.$$typeof === n;
      }
      function Vr() {
        {
          if (ze.current) {
            var i = k(ze.current.type);
            if (i)
              return `

Check the render method of \`` + i + "`.";
          }
          return "";
        }
      }
      function Tn(i) {
        {
          if (i !== void 0) {
            var f = i.fileName.replace(/^.*[\\\/]/, ""), p = i.lineNumber;
            return `

Check your code at ` + f + ":" + p + ".";
          }
          return "";
        }
      }
      var Ur = {};
      function Pn(i) {
        {
          var f = Vr();
          if (!f) {
            var p = typeof i == "string" ? i : i.displayName || i.name;
            p && (f = `

Check the top-level render call using <` + p + ">.");
          }
          return f;
        }
      }
      function kr(i, f) {
        {
          if (!i._store || i._store.validated || i.key != null)
            return;
          i._store.validated = !0;
          var p = Pn(f);
          if (Ur[p])
            return;
          Ur[p] = !0;
          var y = "";
          i && i._owner && i._owner !== ze.current && (y = " It was passed a child from " + k(i._owner.type) + "."), Q(i), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Q(null);
        }
      }
      function Gr(i, f) {
        {
          if (typeof i != "object")
            return;
          if (Array.isArray(i))
            for (var p = 0; p < i.length; p++) {
              var y = i[p];
              Ke(y) && kr(y, f);
            }
          else if (Ke(i))
            i._store && (i._store.validated = !0);
          else if (i) {
            var T = W(i);
            if (typeof T == "function" && T !== i.entries)
              for (var P = T.call(i), E; !(E = P.next()).done; )
                Ke(E.value) && kr(E.value, f);
          }
        }
      }
      function jn(i) {
        {
          var f = i.type;
          if (f == null || typeof f == "string")
            return;
          var p;
          if (typeof f == "function")
            p = f.propTypes;
          else if (typeof f == "object" && (f.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          f.$$typeof === h))
            p = f.propTypes;
          else
            return;
          if (p) {
            var y = k(f);
            yn(p, i.props, "prop", y, i);
          } else if (f.PropTypes !== void 0 && !We) {
            We = !0;
            var T = k(f);
            C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
          }
          typeof f.getDefaultProps == "function" && !f.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Cn(i) {
        {
          for (var f = Object.keys(i.props), p = 0; p < f.length; p++) {
            var y = f[p];
            if (y !== "children" && y !== "key") {
              Q(i), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Q(null);
              break;
            }
          }
          i.ref !== null && (Q(i), C("Invalid attribute `ref` supplied to `React.Fragment`."), Q(null));
        }
      }
      function Br(i, f, p, y, T, P) {
        {
          var E = X(i);
          if (!E) {
            var b = "";
            (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var V = Tn(T);
            V ? b += V : b += Vr();
            var R;
            i === null ? R = "null" : Array.isArray(i) ? R = "array" : i !== void 0 && i.$$typeof === n ? (R = "<" + (k(i.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : R = typeof i, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, b);
          }
          var D = xn(i, f, p, T, P);
          if (D == null)
            return D;
          if (E) {
            var q = f.children;
            if (q !== void 0)
              if (y)
                if (Array.isArray(q)) {
                  for (var ee = 0; ee < q.length; ee++)
                    Gr(q[ee], i);
                  Object.freeze && Object.freeze(q);
                } else
                  C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Gr(q, i);
          }
          return i === e.Fragment ? Cn(D) : jn(D), D;
        }
      }
      function An(i, f, p) {
        return Br(i, f, p, !0);
      }
      function Sn(i, f, p) {
        return Br(i, f, p, !1);
      }
      var Rn = Sn, In = An;
      e.jsx = Rn, e.jsxs = In;
    }();
  }(Ye)), Ye;
}
var re = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qr;
function Xn() {
  if (qr)
    return re;
  qr = 1, Ft();
  var e = cr, r = 60103;
  if (re.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    r = t("react.element"), re.Fragment = t("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, l, c) {
    var v, g = {}, h = null, m = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (v in l)
      a.call(l, v) && !s.hasOwnProperty(v) && (g[v] = l[v]);
    if (u && u.defaultProps)
      for (v in l = u.defaultProps, l)
        g[v] === void 0 && (g[v] = l[v]);
    return { $$typeof: r, type: u, key: h, ref: m, props: g, _owner: n.current };
  }
  return re.jsx = o, re.jsxs = o, re;
}
process.env.NODE_ENV === "production" ? tr.exports = Xn() : tr.exports = Jn();
var d = tr.exports;
const Zn = "_tooltip_12yf1_1", Qn = {
  tooltip: Zn
}, ov = ({
  actions: e,
  direction: r,
  dropdownButtonProps: t = {}
}) => {
  if (!e.length)
    return null;
  const n = (s, o, u) => {
    switch (s.type) {
      case "button":
      case "link": {
        const l = /* @__PURE__ */ d.jsx(
          qe.Item,
          {
            icon: s.icon,
            onClick: () => {
              var c;
              (c = s.onClick) == null || c.call(s), u();
            },
            isDisabled: s.disabled ?? !1,
            children: /* @__PURE__ */ d.jsxs(
              U,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ d.jsx("span", { children: s.label }),
                  s.description && /* @__PURE__ */ d.jsx(G.Paragraph, { as: "span", variant: "4", subdued: !0, children: s.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ d.jsx(
          fr,
          {
            className: Qn.tooltip,
            content: s.tooltip,
            dark: !0,
            children: s.type === "link" ? Dn(s.link, {
              children: l
            }) : l
          },
          o
        );
      }
      case "divider":
        return /* @__PURE__ */ d.jsx(qe.Divider, {}, o);
      default:
        return null;
    }
  }, a = r ? {
    top: "100%",
    bottom: "auto",
    right: r === "left" ? 0 : "auto",
    left: r === "left" ? "auto" : 0,
    margin: `${Bn.spacer[200]} 0 0 0`
  } : {};
  return /* @__PURE__ */ d.jsx(
    Nn,
    {
      icon: "dots-v",
      dropdown: /* @__PURE__ */ d.jsx(Ln.Consumer, { children: ({ toggleDropdown: s }) => /* @__PURE__ */ d.jsx(qe, { children: e.map(
        (o, u) => n(o, u, s)
      ) }) }),
      dropdownProps: {
        ...t.dropdownProps ?? {},
        style: { ...a }
      },
      buttonProps: {
        ...t.buttonProps ?? {},
        variant: "tertiary"
      },
      noArrow: !0,
      ...t
    }
  );
};
var pr = {}, nr = function() {
  return (nr = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++)
      for (var a in r = arguments[t])
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    return e;
  }).apply(this, arguments);
}, ea = function() {
  function e(r, t, n) {
    var a = this;
    this.endVal = t, this.options = n, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(s) {
      a.startTime || (a.startTime = s);
      var o = s - a.startTime;
      a.remaining = a.duration - o, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(o, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(o, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (o / a.duration);
      var u = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = u ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), o < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(s) {
      var o, u, l, c, v = s < 0 ? "-" : "";
      o = Math.abs(s).toFixed(a.options.decimalPlaces);
      var g = (o += "").split(".");
      if (u = g[0], l = g.length > 1 ? a.options.decimal + g[1] : "", a.options.useGrouping) {
        c = "";
        for (var h = 3, m = 0, $ = 0, w = u.length; $ < w; ++$)
          a.options.useIndianSeparators && $ === 4 && (h = 2, m = 1), $ !== 0 && m % h == 0 && (c = a.options.separator + c), m++, c = u[w - $ - 1] + c;
        u = c;
      }
      return a.options.numerals && a.options.numerals.length && (u = u.replace(/[0-9]/g, function(O) {
        return a.options.numerals[+O];
      }), l = l.replace(/[0-9]/g, function(O) {
        return a.options.numerals[+O];
      })), v + a.options.prefix + u + l + a.options.suffix;
    }, this.easeOutExpo = function(s, o, u, l) {
      return u * (1 - Math.pow(2, -10 * s / l)) * 1024 / 1023 + o;
    }, this.options = nr(nr({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(t), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof r == "string" ? document.getElementById(r) : r, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, r) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(s) {
        return s();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(r) {
    if (r && window && !r.once) {
      var t = window.innerHeight + window.scrollY, n = r.el.getBoundingClientRect(), a = n.top + window.pageYOffset, s = n.top + n.height + window.pageYOffset;
      s < t && s > window.scrollY && r.paused ? (r.paused = !1, setTimeout(function() {
        return r.start();
      }, r.options.scrollSpyDelay), r.options.scrollSpyOnce && (r.once = !0)) : (window.scrollY > s || a > t) && !r.paused && r.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var r = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > r;
    var t = r - this.startVal;
    if (Math.abs(t) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = r;
      var n = this.countDown ? 1 : -1;
      this.endVal = r + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else
      this.endVal = r, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(r) {
    this.error || (r && (this.options.onCompleteCallback = r), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(r) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(r), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(r) {
    var t;
    if (this.el) {
      var n = this.formattingFn(r);
      (t = this.options.plugin) !== null && t !== void 0 && t.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
    }
  }, e.prototype.ensureNumber = function(r) {
    return typeof r == "number" && !isNaN(r);
  }, e.prototype.validateValue = function(r) {
    var t = Number(r);
    return this.ensureNumber(t) ? t : (this.error = "[CountUp] invalid start or end value: ".concat(r), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
}();
const ra = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: ea
}, Symbol.toStringTag, { value: "Module" })), ta = /* @__PURE__ */ Yn(ra);
Object.defineProperty(pr, "__esModule", { value: !0 });
var F = cr, na = ta;
function aa(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n, a, s, o, u = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(e)).next, r === 0) {
        if (Object(t) !== t)
          return;
        l = !1;
      } else
        for (; !(l = (n = s.call(t)).done) && (u.push(n.value), u.length !== r); l = !0)
          ;
    } catch (v) {
      c = !0, a = v;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return u;
  }
}
function Yr(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function xe(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Yr(Object(t), !0).forEach(function(n) {
      ia(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Yr(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function ia(e, r, t) {
  return r = da(r), r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ar() {
  return ar = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ar.apply(this, arguments);
}
function sa(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, s;
  for (s = 0; s < n.length; s++)
    a = n[s], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function Nt(e, r) {
  if (e == null)
    return {};
  var t = sa(e, r), n, a;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (a = 0; a < s.length; a++)
      n = s[a], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function oa(e, r) {
  return ua(e) || aa(e, r) || la(e, r) || ca();
}
function ua(e) {
  if (Array.isArray(e))
    return e;
}
function la(e, r) {
  if (e) {
    if (typeof e == "string")
      return Jr(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Jr(e, r);
  }
}
function Jr(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function ca() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fa(e, r) {
  if (typeof e != "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function da(e) {
  var r = fa(e, "string");
  return typeof r == "symbol" ? r : String(r);
}
var pa = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? F.useLayoutEffect : F.useEffect;
function H(e) {
  var r = F.useRef(e);
  return pa(function() {
    r.current = e;
  }), F.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return r.current.apply(void 0, n);
  }, []);
}
var va = function(r, t) {
  var n = t.decimal, a = t.decimals, s = t.duration, o = t.easingFn, u = t.end, l = t.formattingFn, c = t.numerals, v = t.prefix, g = t.separator, h = t.start, m = t.suffix, $ = t.useEasing, w = t.useGrouping, O = t.useIndianSeparators, S = t.enableScrollSpy, x = t.scrollSpyDelay, _ = t.scrollSpyOnce;
  return new na.CountUp(r, u, {
    startVal: h,
    duration: s,
    decimal: n,
    decimalPlaces: a,
    easingFn: o,
    formattingFn: l,
    numerals: c,
    separator: g,
    prefix: v,
    suffix: m,
    useEasing: $,
    useIndianSeparators: O,
    useGrouping: w,
    enableScrollSpy: S,
    scrollSpyDelay: x,
    scrollSpyOnce: _
  });
}, ha = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], ga = {
  decimal: ".",
  separator: ",",
  delay: null,
  prefix: "",
  suffix: "",
  duration: 2,
  start: 0,
  decimals: 0,
  startOnMount: !0,
  enableReinitialize: !0,
  useEasing: !0,
  useGrouping: !0,
  useIndianSeparators: !1
}, Lt = function(r) {
  var t = Object.fromEntries(Object.entries(r).filter(function(L) {
    var K = oa(L, 2), X = K[1];
    return X !== void 0;
  })), n = F.useMemo(function() {
    return xe(xe({}, ga), t);
  }, [r]), a = n.ref, s = n.startOnMount, o = n.enableReinitialize, u = n.delay, l = n.onEnd, c = n.onStart, v = n.onPauseResume, g = n.onReset, h = n.onUpdate, m = Nt(n, ha), $ = F.useRef(), w = F.useRef(), O = F.useRef(!1), S = H(function() {
    return va(typeof a == "string" ? a : a.current, m);
  }), x = H(function(L) {
    var K = $.current;
    if (K && !L)
      return K;
    var X = S();
    return $.current = X, X;
  }), _ = H(function() {
    var L = function() {
      return x(!0).start(function() {
        l == null || l({
          pauseResume: N,
          reset: I,
          start: M,
          update: W
        });
      });
    };
    u && u > 0 ? w.current = setTimeout(L, u * 1e3) : L(), c == null || c({
      pauseResume: N,
      reset: I,
      update: W
    });
  }), N = H(function() {
    x().pauseResume(), v == null || v({
      reset: I,
      start: M,
      update: W
    });
  }), I = H(function() {
    x().el && (w.current && clearTimeout(w.current), x().reset(), g == null || g({
      pauseResume: N,
      start: M,
      update: W
    }));
  }), W = H(function(L) {
    x().update(L), h == null || h({
      pauseResume: N,
      reset: I,
      start: M
    });
  }), M = H(function() {
    I(), _();
  }), C = H(function(L) {
    s && (L && I(), _());
  });
  return F.useEffect(function() {
    O.current ? o && C(!0) : (O.current = !0, C());
  }, [o, O, C, u, r.start, r.suffix, r.prefix, r.duration, r.separator, r.decimals, r.decimal, r.formattingFn]), F.useEffect(function() {
    return function() {
      I();
    };
  }, [I]), {
    start: M,
    pauseResume: N,
    reset: I,
    update: W,
    getCountUp: x
  };
}, ya = ["className", "redraw", "containerProps", "children", "style"], ma = function(r) {
  var t = r.className, n = r.redraw, a = r.containerProps, s = r.children, o = r.style, u = Nt(r, ya), l = F.useRef(null), c = F.useRef(!1), v = Lt(xe(xe({}, u), {}, {
    ref: l,
    startOnMount: typeof s != "function" || r.delay === 0,
    // component manually restarts
    enableReinitialize: !1
  })), g = v.start, h = v.reset, m = v.update, $ = v.pauseResume, w = v.getCountUp, O = H(function() {
    g();
  }), S = H(function(N) {
    r.preserveValue || h(), m(N);
  }), x = H(function() {
    if (typeof r.children == "function" && !(l.current instanceof Element)) {
      console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
      return;
    }
    w();
  });
  F.useEffect(function() {
    x();
  }, [x]), F.useEffect(function() {
    c.current && S(r.end);
  }, [r.end, S]);
  var _ = n && r;
  return F.useEffect(function() {
    n && c.current && O();
  }, [O, n, _]), F.useEffect(function() {
    !n && c.current && O();
  }, [O, n, r.start, r.suffix, r.prefix, r.duration, r.separator, r.decimals, r.decimal, r.className, r.formattingFn]), F.useEffect(function() {
    c.current = !0;
  }, []), typeof s == "function" ? s({
    countUpRef: l,
    start: g,
    reset: h,
    update: m,
    pauseResume: $,
    getCountUp: w
  }) : /* @__PURE__ */ F.createElement("span", ar({
    className: t,
    ref: l,
    style: o
  }, a), typeof r.start < "u" ? w().formattingFn(r.start) : "");
}, _a = pr.default = ma;
pr.useCountUp = Lt;
const ba = "_bar_oizm2_27", $a = "_section_oizm2_31", wa = "_sectionHidden_oizm2_34", Ea = "_sectionInheritRadius_oizm2_37", Oa = "_valueOutside_oizm2_41", te = {
  bar: ba,
  section: $a,
  sectionHidden: wa,
  sectionInheritRadius: Ea,
  valueOutside: Oa
}, Oe = ({
  value: e,
  label: r,
  labelWidth: t,
  theme: n = [A.purple[700], A.neutral[200]],
  showFullBar: a = !1,
  showDifference: s = !1
}) => {
  const o = Math.min(e, 100), [u, l] = Ae([
    null,
    null
  ]), c = zn(u);
  It(() => {
    l([
      o,
      ...a ? [100 - o] : []
    ]);
  }, [o, a]);
  const v = 1.5, g = ne(
    () => u.map((h, m) => {
      const $ = o && m === 0 || s, w = h !== null && h < 20, O = rr(te.section, {
        [te.sectionHidden]: a && h === 0,
        [te.sectionInheritRadius]: !a
      }), S = rr(te.section, {
        [te.valueOutside]: w
      });
      return /* @__PURE__ */ d.jsx(
        U,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: n[m],
          color: "neutral.000",
          className: O,
          style: {
            flexBasis: `${h ?? 0}%`,
            transition: `flex-basis ${v}s ease-out`
          },
          children: $ && /* @__PURE__ */ d.jsx(
            G.Paragraph,
            {
              className: S,
              variant: "4",
              color: m === 0 && !w ? A.neutral["000"] : A.neutral[900],
              children: /* @__PURE__ */ d.jsx(
                _a,
                {
                  start: (c == null ? void 0 : c[m]) ?? 0,
                  end: h ?? 0,
                  duration: v,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: x }) => /* @__PURE__ */ d.jsx("span", { ref: x })
                }
              )
            }
          )
        },
        m
      );
    }),
    [
      o,
      n,
      s,
      a,
      u,
      c
    ]
  );
  return /* @__PURE__ */ d.jsxs(U, { alignItems: "center", gap: "200", children: [
    r && /* @__PURE__ */ d.jsx(dr, { minWidth: t ? `${t}px` : "auto", children: /* @__PURE__ */ d.jsx(G.Paragraph, { variant: "4", children: r }) }),
    /* @__PURE__ */ d.jsx(U, { flex: "1", className: te.bar, height: "20px", borderRadius: "50", children: g })
  ] });
};
function Te(e) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const r = Math.floor(e / 1e3 % 60), t = Math.floor(e / (1e3 * 60) % 60), n = Math.floor(e / (1e3 * 60 * 60) % 24), a = Math.floor(e / (1e3 * 60 * 60 * 24)), s = (u, l) => u > 0 ? `${u}${l}` : "";
  return [
    s(a, "d"),
    s(n, "h"),
    s(t, "m") || "0m",
    s(r, "s") || "0s"
  ].filter(Boolean).join(" ");
}
const Xr = 1e6, Zr = 1e3;
function Vt(e) {
  if (e < Zr)
    return `${e}`;
  const r = e >= Xr;
  return `${parseFloat(
    (e / (r ? Xr : Zr)).toFixed(1)
  )}${r ? "M" : "K"}`;
}
function ve(e) {
  return e.toLocaleString(navigator.language);
}
const uv = (e) => ({
  metrics: e.filter(xa),
  chart: e.find(Ta),
  heatmap: e.find(Pa),
  table: e.find(ja),
  presence: e.find(Ca)
}), xa = (e) => e.type === "metric", Ta = (e) => e.type === "chart" && e.visualization !== "heatmap", Pa = (e) => e.type === "chart" && e.visualization === "heatmap", ja = (e) => e.type === "table", Ca = (e) => e.type === "presence", lv = (e) => e.type === "ai_insight", Ut = (e, r) => {
  switch (r) {
    case "duration":
      return Te(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return Vt(e);
    case "number":
      return ve(e);
    case "percentage":
      return `${ve(e)}%`;
    case "timer":
      return Te(e);
    default:
      return "";
  }
}, vr = [
  {
    name: "default",
    colors: [
      A.purple[700],
      A.blue[300],
      A.red[500],
      A.orange[300],
      A.purple[500],
      A.green[400],
      A.neutral[600],
      A.neutral[300]
    ]
  },
  {
    name: "rating",
    colors: [
      A.red[700],
      A.red[400],
      A.orange[300],
      A.green[500],
      A.green[600]
    ]
  }
], kt = vr[0], Aa = (e) => e.startsWith("#"), Gt = (e) => {
  var a;
  if (Aa(e))
    return e;
  const [r, t] = e.split("-"), n = vr.find((s) => s.name === r) ?? kt;
  return ((a = n == null ? void 0 : n.colors) == null ? void 0 : a[Number(t) - 1]) ?? e;
}, cv = (e, r = "default", t) => {
  if (t)
    return Gt(t);
  const n = vr.find(({ name: a }) => a === r) ?? kt;
  return n.colors[e % n.colors.length];
}, Sa = Se(
  function({
    data: r
  }) {
    const [t, n] = Ae(0);
    return It(() => {
      n(Date.now() - r);
    }, [r]), Wn(() => {
      n(Date.now() - r);
    }, 1e3), /* @__PURE__ */ d.jsx(d.Fragment, { children: Ut(t, "timer") });
  }
), Ra = "_wrapper_1q643_27", Ia = "_text_1q643_32", Qr = {
  wrapper: Ra,
  text: Ia
}, Da = Se(function({
  data: r,
  format: t,
  color: n,
  suffix: a
}) {
  const s = ne(() => {
    if (r === null)
      return "n.a.";
    switch (t) {
      case "timer":
        return /* @__PURE__ */ d.jsx(Sa, { data: r });
      default:
        return Ut(r, t);
    }
  }, [r, t]), o = ne(() => {
    if (r !== null)
      switch (t) {
        case "duration":
          return Te(r);
        case "count":
          return ve(r);
        default:
          return;
      }
  }, [r, t]), l = !(r !== null && o !== s) || ["number", "percentage", "timer"].includes(t);
  return /* @__PURE__ */ d.jsx(
    fr,
    {
      content: o,
      dark: !0,
      disabled: l,
      wrap: "div",
      wrapProps: { className: Qr.wrapper },
      children: /* @__PURE__ */ d.jsxs(
        G.Heading,
        {
          variant: "heading-1",
          color: n ?? (r === null ? Hn.color.tertiary : void 0),
          className: Qr.text,
          as: "span",
          children: [
            s,
            a
          ]
        }
      )
    }
  );
}), Ma = "_colorIndicator_luubh_1", Fa = {
  colorIndicator: Ma
}, fv = Se(function({
  instrument: r,
  theme: t = "light"
}) {
  const { data: n, format: a, title: s, description: o, color: u } = r, l = u ? Gt(u) : void 0, c = t === "dark" ? "white" : void 0;
  return /* @__PURE__ */ d.jsxs(U, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ d.jsxs(U, { alignItems: "center", gap: "100", title: s, children: [
      u && /* @__PURE__ */ d.jsx(
        dr,
        {
          as: "span",
          className: Fa.colorIndicator,
          background: l
        }
      ),
      /* @__PURE__ */ d.jsx(G.Paragraph, { variant: "4", color: c, subdued: !0, children: s })
    ] }),
    /* @__PURE__ */ d.jsx(Da, { data: n, format: a, color: c }),
    o && /* @__PURE__ */ d.jsx(
      G.Paragraph,
      {
        variant: "4",
        color: t === "dark" ? "white" : void 0,
        subdued: !0,
        children: o
      }
    )
  ] });
}), dv = Se(function({
  instrument: r
}) {
  const {
    data: { availability: t, media_type: n }
  } = r, a = [A.purple[700], A.neutral[200]], s = "No data available", o = {
    // Primitive way to ensure the labels are the same width, by derriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...n.map((c) => c.label.length)) * 7,
    theme: a
  }, u = () => /* @__PURE__ */ d.jsx(
    Oe,
    {
      ...o,
      value: 0,
      label: "n.a.",
      theme: [A.neutral[200], A.neutral[200]],
      showFullBar: !0
    }
  ), l = () => /* @__PURE__ */ d.jsx(U, { gap: "300", children: t.map((c, v) => /* @__PURE__ */ d.jsxs(U, { gap: "200", alignItems: "center", children: [
    /* @__PURE__ */ d.jsx(
      dr,
      {
        width: "6px",
        height: "6px",
        background: a[v],
        borderRadius: "50%"
      }
    ),
    /* @__PURE__ */ d.jsx(G.Paragraph, { variant: "4", children: c.label })
  ] }, v)) });
  return /* @__PURE__ */ d.jsxs(U, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ d.jsxs(U, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ d.jsx(G.Paragraph, { variant: "4", subdued: !0, children: t.length ? "Availability" : s }),
      t.length ? /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        l(),
        /* @__PURE__ */ d.jsx(
          Oe,
          {
            ...o,
            value: t[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : u()
    ] }),
    /* @__PURE__ */ d.jsxs(U, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ d.jsx(G.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability per channel" : s }),
      n.length > 0 ? /* @__PURE__ */ d.jsx(U, { flexDirection: "column", gap: "200", children: n.map((c, v) => /* @__PURE__ */ Mn(
        Oe,
        {
          ...o,
          key: v,
          value: c.value,
          label: c.label
        }
      )) }) : u()
    ] })
  ] });
}), Na = "_tooltip_h4i5v_1", La = "_trigger_h4i5v_5", et = {
  tooltip: Na,
  trigger: La
}, Va = ({
  text: e
}) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
  /* @__PURE__ */ d.jsx("span", { children: e }),
  /* @__PURE__ */ d.jsx(
    fr,
    {
      className: et.tooltip,
      content: e,
      dark: !0,
      wrap: "div",
      wrapProps: { className: et.trigger }
    }
  )
] }), Ua = ({
  cell: e,
  format: r,
  timezone: t,
  customFormats: n
}) => {
  const a = ne(() => {
    var o;
    if (!e || ka(e.value))
      return /* @__PURE__ */ d.jsx(G.Paragraph, { variant: "2", color: A.neutral[500], children: "n.a." });
    const { value: s } = e;
    if (n != null && n[r])
      return (o = n[r]) == null ? void 0 : o.call(n, { value: s });
    switch (r) {
      case "boolean":
        return s ? "Y" : "N";
      case "date":
        return qn.tz(s, t).format("L, LT");
      case "count":
        return Vt(s);
      case "number":
        return ve(s);
      case "percentage":
        return `${ve(s)}%`;
      case "duration":
        return Te(s);
      case "csid":
        return `#${s}`;
      case "rating":
        return `${s}`;
      case "presence":
        return /* @__PURE__ */ d.jsx(Oe, { value: s, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ d.jsx(Kn, { tags: s, limit: 1 });
      case "text":
        return /* @__PURE__ */ d.jsx(Va, { text: s });
      case "string":
      default:
        return `${s}`;
    }
  }, [e, n, r, t]);
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: a });
};
function ka(e) {
  const r = e === null, t = typeof e == "string" && e.trim() === "", n = Array.isArray(e) && !e.length;
  return r || t || n;
}
const Ga = "_tableWrapper_1xmkm_1", Ba = "_tableWrapperEmpty_1xmkm_4", Ha = "_thCell_1xmkm_8", za = "_tdCell_1xmkm_12", Wa = "_tooltip_1xmkm_20", de = {
  tableWrapper: Ga,
  tableWrapperEmpty: Ba,
  thCell: Ha,
  tdCell: za,
  tooltip: Wa
};
function Ka(e) {
  return e == null;
}
var qa = Ka;
const Ya = /* @__PURE__ */ Mt(qa);
function Ja(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = Array(n); ++t < n; )
    a[t] = r(e[t], t, e);
  return a;
}
var Bt = Ja, Xa = Array.isArray, z = Xa, Za = typeof we == "object" && we && we.Object === Object && we, Ht = Za, Qa = Ht, ei = typeof self == "object" && self && self.Object === Object && self, ri = Qa || ei || Function("return this")(), J = ri, ti = J, ni = ti.Symbol, Re = ni, rt = Re, zt = Object.prototype, ai = zt.hasOwnProperty, ii = zt.toString, pe = rt ? rt.toStringTag : void 0;
function si(e) {
  var r = ai.call(e, pe), t = e[pe];
  try {
    e[pe] = void 0;
    var n = !0;
  } catch {
  }
  var a = ii.call(e);
  return n && (r ? e[pe] = t : delete e[pe]), a;
}
var oi = si, ui = Object.prototype, li = ui.toString;
function ci(e) {
  return li.call(e);
}
var fi = ci, tt = Re, di = oi, pi = fi, vi = "[object Null]", hi = "[object Undefined]", nt = tt ? tt.toStringTag : void 0;
function gi(e) {
  return e == null ? e === void 0 ? hi : vi : nt && nt in Object(e) ? di(e) : pi(e);
}
var he = gi;
function yi(e) {
  return e != null && typeof e == "object";
}
var ge = yi, mi = he, _i = ge, bi = "[object Symbol]";
function $i(e) {
  return typeof e == "symbol" || _i(e) && mi(e) == bi;
}
var Ie = $i, wi = z, Ei = Ie, Oi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xi = /^\w*$/;
function Ti(e, r) {
  if (wi(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || Ei(e) ? !0 : xi.test(e) || !Oi.test(e) || r != null && e in Object(r);
}
var hr = Ti;
function Pi(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var gr = Pi, ji = he, Ci = gr, Ai = "[object AsyncFunction]", Si = "[object Function]", Ri = "[object GeneratorFunction]", Ii = "[object Proxy]";
function Di(e) {
  if (!Ci(e))
    return !1;
  var r = ji(e);
  return r == Si || r == Ri || r == Ai || r == Ii;
}
var Wt = Di, Mi = J, Fi = Mi["__core-js_shared__"], Ni = Fi, Xe = Ni, at = function() {
  var e = /[^.]+$/.exec(Xe && Xe.keys && Xe.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Li(e) {
  return !!at && at in e;
}
var Vi = Li, Ui = Function.prototype, ki = Ui.toString;
function Gi(e) {
  if (e != null) {
    try {
      return ki.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Kt = Gi, Bi = Wt, Hi = Vi, zi = gr, Wi = Kt, Ki = /[\\^$.*+?()[\]{}|]/g, qi = /^\[object .+?Constructor\]$/, Yi = Function.prototype, Ji = Object.prototype, Xi = Yi.toString, Zi = Ji.hasOwnProperty, Qi = RegExp(
  "^" + Xi.call(Zi).replace(Ki, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function es(e) {
  if (!zi(e) || Hi(e))
    return !1;
  var r = Bi(e) ? Qi : qi;
  return r.test(Wi(e));
}
var rs = es;
function ts(e, r) {
  return e == null ? void 0 : e[r];
}
var ns = ts, as = rs, is = ns;
function ss(e, r) {
  var t = is(e, r);
  return as(t) ? t : void 0;
}
var ae = ss, os = ae, us = os(Object, "create"), De = us, it = De;
function ls() {
  this.__data__ = it ? it(null) : {}, this.size = 0;
}
var cs = ls;
function fs(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var ds = fs, ps = De, vs = "__lodash_hash_undefined__", hs = Object.prototype, gs = hs.hasOwnProperty;
function ys(e) {
  var r = this.__data__;
  if (ps) {
    var t = r[e];
    return t === vs ? void 0 : t;
  }
  return gs.call(r, e) ? r[e] : void 0;
}
var ms = ys, _s = De, bs = Object.prototype, $s = bs.hasOwnProperty;
function ws(e) {
  var r = this.__data__;
  return _s ? r[e] !== void 0 : $s.call(r, e);
}
var Es = ws, Os = De, xs = "__lodash_hash_undefined__";
function Ts(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Os && r === void 0 ? xs : r, this;
}
var Ps = Ts, js = cs, Cs = ds, As = ms, Ss = Es, Rs = Ps;
function ie(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
ie.prototype.clear = js;
ie.prototype.delete = Cs;
ie.prototype.get = As;
ie.prototype.has = Ss;
ie.prototype.set = Rs;
var Is = ie;
function Ds() {
  this.__data__ = [], this.size = 0;
}
var Ms = Ds;
function Fs(e, r) {
  return e === r || e !== e && r !== r;
}
var qt = Fs, Ns = qt;
function Ls(e, r) {
  for (var t = e.length; t--; )
    if (Ns(e[t][0], r))
      return t;
  return -1;
}
var Me = Ls, Vs = Me, Us = Array.prototype, ks = Us.splice;
function Gs(e) {
  var r = this.__data__, t = Vs(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : ks.call(r, t, 1), --this.size, !0;
}
var Bs = Gs, Hs = Me;
function zs(e) {
  var r = this.__data__, t = Hs(r, e);
  return t < 0 ? void 0 : r[t][1];
}
var Ws = zs, Ks = Me;
function qs(e) {
  return Ks(this.__data__, e) > -1;
}
var Ys = qs, Js = Me;
function Xs(e, r) {
  var t = this.__data__, n = Js(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
var Zs = Xs, Qs = Ms, eo = Bs, ro = Ws, to = Ys, no = Zs;
function se(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
se.prototype.clear = Qs;
se.prototype.delete = eo;
se.prototype.get = ro;
se.prototype.has = to;
se.prototype.set = no;
var Fe = se, ao = ae, io = J, so = ao(io, "Map"), yr = so, st = Is, oo = Fe, uo = yr;
function lo() {
  this.size = 0, this.__data__ = {
    hash: new st(),
    map: new (uo || oo)(),
    string: new st()
  };
}
var co = lo;
function fo(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
var po = fo, vo = po;
function ho(e, r) {
  var t = e.__data__;
  return vo(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
var Ne = ho, go = Ne;
function yo(e) {
  var r = go(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
var mo = yo, _o = Ne;
function bo(e) {
  return _o(this, e).get(e);
}
var $o = bo, wo = Ne;
function Eo(e) {
  return wo(this, e).has(e);
}
var Oo = Eo, xo = Ne;
function To(e, r) {
  var t = xo(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
var Po = To, jo = co, Co = mo, Ao = $o, So = Oo, Ro = Po;
function oe(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
oe.prototype.clear = jo;
oe.prototype.delete = Co;
oe.prototype.get = Ao;
oe.prototype.has = So;
oe.prototype.set = Ro;
var mr = oe, Yt = mr, Io = "Expected a function";
function _r(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(Io);
  var t = function() {
    var n = arguments, a = r ? r.apply(this, n) : n[0], s = t.cache;
    if (s.has(a))
      return s.get(a);
    var o = e.apply(this, n);
    return t.cache = s.set(a, o) || s, o;
  };
  return t.cache = new (_r.Cache || Yt)(), t;
}
_r.Cache = Yt;
var Do = _r, Mo = Do, Fo = 500;
function No(e) {
  var r = Mo(e, function(n) {
    return t.size === Fo && t.clear(), n;
  }), t = r.cache;
  return r;
}
var Lo = No, Vo = Lo, Uo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ko = /\\(\\)?/g, Go = Vo(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(Uo, function(t, n, a, s) {
    r.push(a ? s.replace(ko, "$1") : n || t);
  }), r;
}), Bo = Go, ot = Re, Ho = Bt, zo = z, Wo = Ie, Ko = 1 / 0, ut = ot ? ot.prototype : void 0, lt = ut ? ut.toString : void 0;
function Jt(e) {
  if (typeof e == "string")
    return e;
  if (zo(e))
    return Ho(e, Jt) + "";
  if (Wo(e))
    return lt ? lt.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -Ko ? "-0" : r;
}
var qo = Jt, Yo = qo;
function Jo(e) {
  return e == null ? "" : Yo(e);
}
var Xo = Jo, Zo = z, Qo = hr, eu = Bo, ru = Xo;
function tu(e, r) {
  return Zo(e) ? e : Qo(e, r) ? [e] : eu(ru(e));
}
var Xt = tu, nu = Ie, au = 1 / 0;
function iu(e) {
  if (typeof e == "string" || nu(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -au ? "-0" : r;
}
var Le = iu, su = Xt, ou = Le;
function uu(e, r) {
  r = su(r, e);
  for (var t = 0, n = r.length; e != null && t < n; )
    e = e[ou(r[t++])];
  return t && t == n ? e : void 0;
}
var br = uu, lu = Fe;
function cu() {
  this.__data__ = new lu(), this.size = 0;
}
var fu = cu;
function du(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
var pu = du;
function vu(e) {
  return this.__data__.get(e);
}
var hu = vu;
function gu(e) {
  return this.__data__.has(e);
}
var yu = gu, mu = Fe, _u = yr, bu = mr, $u = 200;
function wu(e, r) {
  var t = this.__data__;
  if (t instanceof mu) {
    var n = t.__data__;
    if (!_u || n.length < $u - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new bu(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
var Eu = wu, Ou = Fe, xu = fu, Tu = pu, Pu = hu, ju = yu, Cu = Eu;
function ue(e) {
  var r = this.__data__ = new Ou(e);
  this.size = r.size;
}
ue.prototype.clear = xu;
ue.prototype.delete = Tu;
ue.prototype.get = Pu;
ue.prototype.has = ju;
ue.prototype.set = Cu;
var Zt = ue, Au = "__lodash_hash_undefined__";
function Su(e) {
  return this.__data__.set(e, Au), this;
}
var Ru = Su;
function Iu(e) {
  return this.__data__.has(e);
}
var Du = Iu, Mu = mr, Fu = Ru, Nu = Du;
function Pe(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new Mu(); ++r < t; )
    this.add(e[r]);
}
Pe.prototype.add = Pe.prototype.push = Fu;
Pe.prototype.has = Nu;
var Lu = Pe;
function Vu(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n; )
    if (r(e[t], t, e))
      return !0;
  return !1;
}
var Uu = Vu;
function ku(e, r) {
  return e.has(r);
}
var Gu = ku, Bu = Lu, Hu = Uu, zu = Gu, Wu = 1, Ku = 2;
function qu(e, r, t, n, a, s) {
  var o = t & Wu, u = e.length, l = r.length;
  if (u != l && !(o && l > u))
    return !1;
  var c = s.get(e), v = s.get(r);
  if (c && v)
    return c == r && v == e;
  var g = -1, h = !0, m = t & Ku ? new Bu() : void 0;
  for (s.set(e, r), s.set(r, e); ++g < u; ) {
    var $ = e[g], w = r[g];
    if (n)
      var O = o ? n(w, $, g, r, e, s) : n($, w, g, e, r, s);
    if (O !== void 0) {
      if (O)
        continue;
      h = !1;
      break;
    }
    if (m) {
      if (!Hu(r, function(S, x) {
        if (!zu(m, x) && ($ === S || a($, S, t, n, s)))
          return m.push(x);
      })) {
        h = !1;
        break;
      }
    } else if (!($ === w || a($, w, t, n, s))) {
      h = !1;
      break;
    }
  }
  return s.delete(e), s.delete(r), h;
}
var Qt = qu, Yu = J, Ju = Yu.Uint8Array, Xu = Ju;
function Zu(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n, a) {
    t[++r] = [a, n];
  }), t;
}
var Qu = Zu;
function el(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n) {
    t[++r] = n;
  }), t;
}
var rl = el, ct = Re, ft = Xu, tl = qt, nl = Qt, al = Qu, il = rl, sl = 1, ol = 2, ul = "[object Boolean]", ll = "[object Date]", cl = "[object Error]", fl = "[object Map]", dl = "[object Number]", pl = "[object RegExp]", vl = "[object Set]", hl = "[object String]", gl = "[object Symbol]", yl = "[object ArrayBuffer]", ml = "[object DataView]", dt = ct ? ct.prototype : void 0, Ze = dt ? dt.valueOf : void 0;
function _l(e, r, t, n, a, s, o) {
  switch (t) {
    case ml:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case yl:
      return !(e.byteLength != r.byteLength || !s(new ft(e), new ft(r)));
    case ul:
    case ll:
    case dl:
      return tl(+e, +r);
    case cl:
      return e.name == r.name && e.message == r.message;
    case pl:
    case hl:
      return e == r + "";
    case fl:
      var u = al;
    case vl:
      var l = n & sl;
      if (u || (u = il), e.size != r.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == r;
      n |= ol, o.set(e, r);
      var v = nl(u(e), u(r), n, a, s, o);
      return o.delete(e), v;
    case gl:
      if (Ze)
        return Ze.call(e) == Ze.call(r);
  }
  return !1;
}
var bl = _l;
function $l(e, r) {
  for (var t = -1, n = r.length, a = e.length; ++t < n; )
    e[a + t] = r[t];
  return e;
}
var wl = $l, El = wl, Ol = z;
function xl(e, r, t) {
  var n = r(e);
  return Ol(e) ? n : El(n, t(e));
}
var Tl = xl;
function Pl(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++t < n; ) {
    var o = e[t];
    r(o, t, e) && (s[a++] = o);
  }
  return s;
}
var jl = Pl;
function Cl() {
  return [];
}
var Al = Cl, Sl = jl, Rl = Al, Il = Object.prototype, Dl = Il.propertyIsEnumerable, pt = Object.getOwnPropertySymbols, Ml = pt ? function(e) {
  return e == null ? [] : (e = Object(e), Sl(pt(e), function(r) {
    return Dl.call(e, r);
  }));
} : Rl, Fl = Ml;
function Nl(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var Ll = Nl, Vl = he, Ul = ge, kl = "[object Arguments]";
function Gl(e) {
  return Ul(e) && Vl(e) == kl;
}
var Bl = Gl, vt = Bl, Hl = ge, en = Object.prototype, zl = en.hasOwnProperty, Wl = en.propertyIsEnumerable, Kl = vt(function() {
  return arguments;
}()) ? vt : function(e) {
  return Hl(e) && zl.call(e, "callee") && !Wl.call(e, "callee");
}, rn = Kl, je = { exports: {} };
function ql() {
  return !1;
}
var Yl = ql;
je.exports;
(function(e, r) {
  var t = J, n = Yl, a = r && !r.nodeType && r, s = a && !0 && e && !e.nodeType && e, o = s && s.exports === a, u = o ? t.Buffer : void 0, l = u ? u.isBuffer : void 0, c = l || n;
  e.exports = c;
})(je, je.exports);
var tn = je.exports, Jl = 9007199254740991, Xl = /^(?:0|[1-9]\d*)$/;
function Zl(e, r) {
  var t = typeof e;
  return r = r ?? Jl, !!r && (t == "number" || t != "symbol" && Xl.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var nn = Zl, Ql = 9007199254740991;
function ec(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ql;
}
var $r = ec, rc = he, tc = $r, nc = ge, ac = "[object Arguments]", ic = "[object Array]", sc = "[object Boolean]", oc = "[object Date]", uc = "[object Error]", lc = "[object Function]", cc = "[object Map]", fc = "[object Number]", dc = "[object Object]", pc = "[object RegExp]", vc = "[object Set]", hc = "[object String]", gc = "[object WeakMap]", yc = "[object ArrayBuffer]", mc = "[object DataView]", _c = "[object Float32Array]", bc = "[object Float64Array]", $c = "[object Int8Array]", wc = "[object Int16Array]", Ec = "[object Int32Array]", Oc = "[object Uint8Array]", xc = "[object Uint8ClampedArray]", Tc = "[object Uint16Array]", Pc = "[object Uint32Array]", j = {};
j[_c] = j[bc] = j[$c] = j[wc] = j[Ec] = j[Oc] = j[xc] = j[Tc] = j[Pc] = !0;
j[ac] = j[ic] = j[yc] = j[sc] = j[mc] = j[oc] = j[uc] = j[lc] = j[cc] = j[fc] = j[dc] = j[pc] = j[vc] = j[hc] = j[gc] = !1;
function jc(e) {
  return nc(e) && tc(e.length) && !!j[rc(e)];
}
var Cc = jc;
function Ac(e) {
  return function(r) {
    return e(r);
  };
}
var an = Ac, Ce = { exports: {} };
Ce.exports;
(function(e, r) {
  var t = Ht, n = r && !r.nodeType && r, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, o = s && t.process, u = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = u;
})(Ce, Ce.exports);
var Sc = Ce.exports, Rc = Cc, Ic = an, ht = Sc, gt = ht && ht.isTypedArray, Dc = gt ? Ic(gt) : Rc, sn = Dc, Mc = Ll, Fc = rn, Nc = z, Lc = tn, Vc = nn, Uc = sn, kc = Object.prototype, Gc = kc.hasOwnProperty;
function Bc(e, r) {
  var t = Nc(e), n = !t && Fc(e), a = !t && !n && Lc(e), s = !t && !n && !a && Uc(e), o = t || n || a || s, u = o ? Mc(e.length, String) : [], l = u.length;
  for (var c in e)
    (r || Gc.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Vc(c, l))) && u.push(c);
  return u;
}
var Hc = Bc, zc = Object.prototype;
function Wc(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || zc;
  return e === t;
}
var Kc = Wc;
function qc(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var Yc = qc, Jc = Yc, Xc = Jc(Object.keys, Object), Zc = Xc, Qc = Kc, ef = Zc, rf = Object.prototype, tf = rf.hasOwnProperty;
function nf(e) {
  if (!Qc(e))
    return ef(e);
  var r = [];
  for (var t in Object(e))
    tf.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
var af = nf, sf = Wt, of = $r;
function uf(e) {
  return e != null && of(e.length) && !sf(e);
}
var wr = uf, lf = Hc, cf = af, ff = wr;
function df(e) {
  return ff(e) ? lf(e) : cf(e);
}
var Er = df, pf = Tl, vf = Fl, hf = Er;
function gf(e) {
  return pf(e, hf, vf);
}
var yf = gf, yt = yf, mf = 1, _f = Object.prototype, bf = _f.hasOwnProperty;
function $f(e, r, t, n, a, s) {
  var o = t & mf, u = yt(e), l = u.length, c = yt(r), v = c.length;
  if (l != v && !o)
    return !1;
  for (var g = l; g--; ) {
    var h = u[g];
    if (!(o ? h in r : bf.call(r, h)))
      return !1;
  }
  var m = s.get(e), $ = s.get(r);
  if (m && $)
    return m == r && $ == e;
  var w = !0;
  s.set(e, r), s.set(r, e);
  for (var O = o; ++g < l; ) {
    h = u[g];
    var S = e[h], x = r[h];
    if (n)
      var _ = o ? n(x, S, h, r, e, s) : n(S, x, h, e, r, s);
    if (!(_ === void 0 ? S === x || a(S, x, t, n, s) : _)) {
      w = !1;
      break;
    }
    O || (O = h == "constructor");
  }
  if (w && !O) {
    var N = e.constructor, I = r.constructor;
    N != I && "constructor" in e && "constructor" in r && !(typeof N == "function" && N instanceof N && typeof I == "function" && I instanceof I) && (w = !1);
  }
  return s.delete(e), s.delete(r), w;
}
var wf = $f, Ef = ae, Of = J, xf = Ef(Of, "DataView"), Tf = xf, Pf = ae, jf = J, Cf = Pf(jf, "Promise"), Af = Cf, Sf = ae, Rf = J, If = Sf(Rf, "Set"), Df = If, Mf = ae, Ff = J, Nf = Mf(Ff, "WeakMap"), Lf = Nf, ir = Tf, sr = yr, or = Af, ur = Df, lr = Lf, on = he, le = Kt, mt = "[object Map]", Vf = "[object Object]", _t = "[object Promise]", bt = "[object Set]", $t = "[object WeakMap]", wt = "[object DataView]", Uf = le(ir), kf = le(sr), Gf = le(or), Bf = le(ur), Hf = le(lr), Z = on;
(ir && Z(new ir(new ArrayBuffer(1))) != wt || sr && Z(new sr()) != mt || or && Z(or.resolve()) != _t || ur && Z(new ur()) != bt || lr && Z(new lr()) != $t) && (Z = function(e) {
  var r = on(e), t = r == Vf ? e.constructor : void 0, n = t ? le(t) : "";
  if (n)
    switch (n) {
      case Uf:
        return wt;
      case kf:
        return mt;
      case Gf:
        return _t;
      case Bf:
        return bt;
      case Hf:
        return $t;
    }
  return r;
});
var zf = Z, Qe = Zt, Wf = Qt, Kf = bl, qf = wf, Et = zf, Ot = z, xt = tn, Yf = sn, Jf = 1, Tt = "[object Arguments]", Pt = "[object Array]", Ee = "[object Object]", Xf = Object.prototype, jt = Xf.hasOwnProperty;
function Zf(e, r, t, n, a, s) {
  var o = Ot(e), u = Ot(r), l = o ? Pt : Et(e), c = u ? Pt : Et(r);
  l = l == Tt ? Ee : l, c = c == Tt ? Ee : c;
  var v = l == Ee, g = c == Ee, h = l == c;
  if (h && xt(e)) {
    if (!xt(r))
      return !1;
    o = !0, v = !1;
  }
  if (h && !v)
    return s || (s = new Qe()), o || Yf(e) ? Wf(e, r, t, n, a, s) : Kf(e, r, l, t, n, a, s);
  if (!(t & Jf)) {
    var m = v && jt.call(e, "__wrapped__"), $ = g && jt.call(r, "__wrapped__");
    if (m || $) {
      var w = m ? e.value() : e, O = $ ? r.value() : r;
      return s || (s = new Qe()), a(w, O, t, n, s);
    }
  }
  return h ? (s || (s = new Qe()), qf(e, r, t, n, a, s)) : !1;
}
var Qf = Zf, ed = Qf, Ct = ge;
function un(e, r, t, n, a) {
  return e === r ? !0 : e == null || r == null || !Ct(e) && !Ct(r) ? e !== e && r !== r : ed(e, r, t, n, un, a);
}
var ln = un, rd = Zt, td = ln, nd = 1, ad = 2;
function id(e, r, t, n) {
  var a = t.length, s = a, o = !n;
  if (e == null)
    return !s;
  for (e = Object(e); a--; ) {
    var u = t[a];
    if (o && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++a < s; ) {
    u = t[a];
    var l = u[0], c = e[l], v = u[1];
    if (o && u[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var g = new rd();
      if (n)
        var h = n(c, v, l, e, r, g);
      if (!(h === void 0 ? td(v, c, nd | ad, n, g) : h))
        return !1;
    }
  }
  return !0;
}
var sd = id, od = gr;
function ud(e) {
  return e === e && !od(e);
}
var cn = ud, ld = cn, cd = Er;
function fd(e) {
  for (var r = cd(e), t = r.length; t--; ) {
    var n = r[t], a = e[n];
    r[t] = [n, a, ld(a)];
  }
  return r;
}
var dd = fd;
function pd(e, r) {
  return function(t) {
    return t == null ? !1 : t[e] === r && (r !== void 0 || e in Object(t));
  };
}
var fn = pd, vd = sd, hd = dd, gd = fn;
function yd(e) {
  var r = hd(e);
  return r.length == 1 && r[0][2] ? gd(r[0][0], r[0][1]) : function(t) {
    return t === e || vd(t, e, r);
  };
}
var md = yd, _d = br;
function bd(e, r, t) {
  var n = e == null ? void 0 : _d(e, r);
  return n === void 0 ? t : n;
}
var $d = bd;
function wd(e, r) {
  return e != null && r in Object(e);
}
var Ed = wd, Od = Xt, xd = rn, Td = z, Pd = nn, jd = $r, Cd = Le;
function Ad(e, r, t) {
  r = Od(r, e);
  for (var n = -1, a = r.length, s = !1; ++n < a; ) {
    var o = Cd(r[n]);
    if (!(s = e != null && t(e, o)))
      break;
    e = e[o];
  }
  return s || ++n != a ? s : (a = e == null ? 0 : e.length, !!a && jd(a) && Pd(o, a) && (Td(e) || xd(e)));
}
var Sd = Ad, Rd = Ed, Id = Sd;
function Dd(e, r) {
  return e != null && Id(e, r, Rd);
}
var Md = Dd, Fd = ln, Nd = $d, Ld = Md, Vd = hr, Ud = cn, kd = fn, Gd = Le, Bd = 1, Hd = 2;
function zd(e, r) {
  return Vd(e) && Ud(r) ? kd(Gd(e), r) : function(t) {
    var n = Nd(t, e);
    return n === void 0 && n === r ? Ld(t, e) : Fd(r, n, Bd | Hd);
  };
}
var Wd = zd;
function Kd(e) {
  return e;
}
var dn = Kd;
function qd(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
var Yd = qd, Jd = br;
function Xd(e) {
  return function(r) {
    return Jd(r, e);
  };
}
var Zd = Xd, Qd = Yd, ep = Zd, rp = hr, tp = Le;
function np(e) {
  return rp(e) ? Qd(tp(e)) : ep(e);
}
var ap = np, ip = md, sp = Wd, op = dn, up = z, lp = ap;
function cp(e) {
  return typeof e == "function" ? e : e == null ? op : typeof e == "object" ? up(e) ? sp(e[0], e[1]) : ip(e) : lp(e);
}
var fp = cp;
function dp(e) {
  return function(r, t, n) {
    for (var a = -1, s = Object(r), o = n(r), u = o.length; u--; ) {
      var l = o[e ? u : ++a];
      if (t(s[l], l, s) === !1)
        break;
    }
    return r;
  };
}
var pp = dp, vp = pp, hp = vp(), gp = hp, yp = gp, mp = Er;
function _p(e, r) {
  return e && yp(e, r, mp);
}
var bp = _p, $p = wr;
function wp(e, r) {
  return function(t, n) {
    if (t == null)
      return t;
    if (!$p(t))
      return e(t, n);
    for (var a = t.length, s = r ? a : -1, o = Object(t); (r ? s-- : ++s < a) && n(o[s], s, o) !== !1; )
      ;
    return t;
  };
}
var Ep = wp, Op = bp, xp = Ep, Tp = xp(Op), Pp = Tp, jp = Pp, Cp = wr;
function Ap(e, r) {
  var t = -1, n = Cp(e) ? Array(e.length) : [];
  return jp(e, function(a, s, o) {
    n[++t] = r(a, s, o);
  }), n;
}
var Sp = Ap;
function Rp(e, r) {
  var t = e.length;
  for (e.sort(r); t--; )
    e[t] = e[t].value;
  return e;
}
var Ip = Rp, At = Ie;
function Dp(e, r) {
  if (e !== r) {
    var t = e !== void 0, n = e === null, a = e === e, s = At(e), o = r !== void 0, u = r === null, l = r === r, c = At(r);
    if (!u && !c && !s && e > r || s && o && l && !u && !c || n && o && l || !t && l || !a)
      return 1;
    if (!n && !s && !c && e < r || c && t && a && !n && !s || u && t && a || !o && a || !l)
      return -1;
  }
  return 0;
}
var Mp = Dp, Fp = Mp;
function Np(e, r, t) {
  for (var n = -1, a = e.criteria, s = r.criteria, o = a.length, u = t.length; ++n < o; ) {
    var l = Fp(a[n], s[n]);
    if (l) {
      if (n >= u)
        return l;
      var c = t[n];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - r.index;
}
var Lp = Np, er = Bt, Vp = br, Up = fp, kp = Sp, Gp = Ip, Bp = an, Hp = Lp, zp = dn, Wp = z;
function Kp(e, r, t) {
  r.length ? r = er(r, function(s) {
    return Wp(s) ? function(o) {
      return Vp(o, s.length === 1 ? s[0] : s);
    } : s;
  }) : r = [zp];
  var n = -1;
  r = er(r, Bp(Up));
  var a = kp(e, function(s, o, u) {
    var l = er(r, function(c) {
      return c(s);
    });
    return { criteria: l, index: ++n, value: s };
  });
  return Gp(a, function(s, o) {
    return Hp(s, o, t);
  });
}
var qp = Kp, Yp = qp, St = z;
function Jp(e, r, t, n) {
  return e == null ? [] : (St(r) || (r = r == null ? [] : [r]), t = n ? void 0 : t, St(t) || (t = t == null ? [] : [t]), Yp(e, r, t));
}
var Xp = Jp;
const Zp = /* @__PURE__ */ Mt(Xp), Rt = (e, r) => {
  var t;
  return (t = e.cells.find((n) => n.column === r.key)) == null ? void 0 : t.value;
}, Qp = ({
  data: { columns: e, rows: r },
  limit: t = 50,
  sortStatus: n
}) => {
  const s = Math.ceil(r.length / t), [o, u] = Ae(1);
  Dt(() => {
    o !== 1 && u(1);
  }, [n, s]);
  const l = ne(() => {
    if (!n)
      return r;
    const v = e.find(({ key: g }) => g === n.sortBy);
    return v ? Zp(
      r,
      [
        (g) => !Ya(Rt(g, v)),
        (g) => Rt(g, v)
      ],
      ["desc", n.direction]
    ) : r;
  }, [e, r, n]);
  return {
    rows: ne(
      () => l.slice((o - 1) * t, o * t),
      [o, t, l]
    ),
    currentPage: o,
    totalPages: s,
    setPage: u
  };
}, pv = ({
  instrument: e,
  timezone: r,
  onReadInstruments: t,
  onLoadAll: n,
  onSortChange: a,
  customFormats: s
}) => {
  const {
    title: o,
    data: u,
    data: { columns: l, options: c }
  } = e, [v, g] = Ae(null), h = Fn(null), m = (c == null ? void 0 : c.limit) ?? 50, { rows: $, currentPage: w, totalPages: O, setPage: S } = Qp({
    data: u,
    limit: m,
    sortStatus: v
  }), x = u.rows.length === 0, _ = !!(c != null && c.next_page), N = !_ && O > 1;
  Dt(() => {
    h.current && (h.current.scrollTop = 0);
  }, [w]);
  const I = zr(() => (n == null || n(), t({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [n, t]), W = zr(
    async (M) => {
      _ && await I(), g(M), a == null || a(M);
    },
    [I, a, _]
  );
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    o && /* @__PURE__ */ d.jsx("div", { children: /* @__PURE__ */ d.jsx(G.Heading, { variant: "heading-4", children: o }) }),
    /* @__PURE__ */ d.jsxs(
      B,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: v,
          onSortChange: W
        },
        wrapperProps: {
          className: rr(de.tableWrapper, {
            [de.tableWrapperEmpty]: x
          })
        },
        wrapperRef: h,
        hoverable: !x,
        children: [
          /* @__PURE__ */ d.jsx(B.Thead, { children: /* @__PURE__ */ d.jsx(B.Tr, { children: l.map(({ key: M, label: C, sortable: L }) => /* @__PURE__ */ d.jsx(
            B.Th,
            {
              className: de.thCell,
              columnId: L ? M : null,
              children: C
            },
            C
          )) }) }),
          /* @__PURE__ */ d.jsxs(B.Tbody, { children: [
            x && /* @__PURE__ */ d.jsx(B.Tr, { children: /* @__PURE__ */ d.jsx(B.Td, { colSpan: l.length, children: /* @__PURE__ */ d.jsx(
              Vn,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            $.map((M, C) => {
              const L = `row-${C}`;
              return /* @__PURE__ */ d.jsx(B.Tr, { children: l.map(({ key: K, format: X }, Ve) => {
                const ye = M.cells.find((k) => k.column === K);
                return /* @__PURE__ */ d.jsx(
                  B.Td,
                  {
                    className: de.tdCell,
                    children: /* @__PURE__ */ d.jsx(
                      Ua,
                      {
                        cell: ye,
                        format: X,
                        timezone: r,
                        customFormats: s
                      }
                    )
                  },
                  `${L}-cell-${Ve}`
                );
              }) }, L);
            })
          ] }),
          _ && /* @__PURE__ */ d.jsx(B.Footer, { children: /* @__PURE__ */ d.jsxs(U, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ d.jsxs(U, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ d.jsx(
                Un,
                {
                  tooltipClassName: de.tooltip,
                  text: `By default we only load the first ${m} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`,
                  dark: !0
                }
              ),
              /* @__PURE__ */ d.jsxs(G.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ d.jsxs("b", { children: [
                  "first ",
                  m,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ d.jsx(kn, { variant: "secondary", onClick: I, children: "Load all results" })
          ] }) }),
          N && /* @__PURE__ */ d.jsx(B.Footer, { children: /* @__PURE__ */ d.jsx(U, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ d.jsx(
            Gn,
            {
              pageCount: O,
              currentPage: w,
              pageRangeDisplayed: 6,
              onPageChange: S
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  ov as AnalyticsMenu,
  fv as MetricInstrument,
  Da as MetricInstrumentData,
  Oe as PercentageBar,
  dv as PresenceInstrument,
  pv as TableInstrument,
  uv as categorizeInstruments,
  Vt as formatAbbreviateNumber,
  Ut as formatInstrumentNumber,
  ve as formatLocalizedNumber,
  Te as formatMillisecondsToDuration,
  Ta as isChartInstrument,
  Pa as isHeatmapInstrument,
  lv as isInsightInstrument,
  xa as isMetricInstrument,
  Ca as isPresenceInstrument,
  ja as isTableInstrument,
  cv as resolveChartElementColor,
  Gt as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
